//These lengths are obtained from the CustomData database. Going over them can sometimes result in SQL errors.

angular
  .module("alk.constants")
  /** @name MAXDBLENGTHS
   * @ngdoc constant
   * @description Provides an object that contains the sizes of fields in the CustomData database
   * for various types of objects.
   * @example
   * var input = "1 Independence Way";
   * if (input.length > MAXDBLENGTHS["Street"]) {
   *   // return a validation error
   * }
   * @memberof alk.constants
   */
  .constant("MAXDBLENGTHS", {
    //Common
    STREET: 100,
    CITY: 100,
    ZIP: 25,
    PHONE: 20,
    COUNTY: 100,
    COUNTRY: 100, //??? doesn't seem to be a field in TLocations table. Just using 100 for now

    //Places
    PLACE_NAME: 140,
    CID: 24,
    YARD_NAME: 100,
    SITE_DETAIL: 1000,
    PLACE_COMMENTS: 140,
    YARD_GATE_NOTE: 60,
  });



// WEBPACK FOOTER //
// ./Common Javascript Files/AngularJS/alk-constants/maxDbLengths.js